import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ContractorPortalStep } from 'enums/ContractorPortalStep';
import { DashboardStep } from 'enums/DashboardStep';
import { PreQualificationStep } from 'enums/PreQualificationStep';
import { SignInStep } from 'enums/SignInStep';

interface StagesState {
  currentPreQualificationStep: PreQualificationStep | null;
  currentSignInStep: SignInStep | null;
  currentDashboardStep: DashboardStep | null;
  currentContractorPortalStep: ContractorPortalStep | null;
}

const initialState: StagesState = {
  currentPreQualificationStep: null,
  currentSignInStep: null,
  currentDashboardStep: null,
  currentContractorPortalStep: null,
};

const stages = createSlice({
  name: 'stages',
  initialState,
  reducers: {
    setPreQualificationStep(state, { payload }: PayloadAction<PreQualificationStep | null>) {
      state.currentPreQualificationStep = payload;
    },
    setDashboardStep(state, { payload }: PayloadAction<DashboardStep | null>) {
      state.currentDashboardStep = payload;
    },
    setSignInStep(state, { payload }: PayloadAction<SignInStep | null>) {
      state.currentSignInStep = payload;
    },
    setContractorPortalStep(state, { payload }: PayloadAction<ContractorPortalStep | null>) {
      state.currentContractorPortalStep = payload;
    },
    resetAllSteps(state) {
      state.currentContractorPortalStep = null;
      state.currentSignInStep = null;
      state.currentDashboardStep = null;
      state.currentPreQualificationStep = null;
    },
  },
});

export const { setPreQualificationStep, setDashboardStep, setSignInStep, setContractorPortalStep, resetAllSteps } =
  stages.actions;

export default stages.reducer;
